import { selectIsCampaignPerformanceAlertsFeatureFlagOn } from 'core/userContext';
import { GraphQLCampaign } from 'modules/campaigns/lib';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useCancelCampaignAlertsMutation } from './useCancelCampaignAlertsMutation';

export const useCancelCampaignAlerts = () => {
  const isCampaignPerformanceAlertsEnabled = useSelector(
    selectIsCampaignPerformanceAlertsFeatureFlagOn,
  );

  const { cancelCampaignAlerts: cancelAlerts } = useCancelCampaignAlertsMutation();

  const cancelCampaignAlerts = useCallback(
    ({
      campaignIds,
      campaignAlertsEnabled,
    }: {
      campaignAlertsEnabled: GraphQLCampaign['campaignAlertsEnabled'];
      campaignIds: GraphQLCampaign['id'][];
    }) => {
      if (isCampaignPerformanceAlertsEnabled && campaignAlertsEnabled) {
        cancelAlerts({
          variables: { campaignIds },
        });
      }
    },
    [isCampaignPerformanceAlertsEnabled],
  );

  return {
    cancelCampaignAlerts,
  };
};
